import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const OrderDate = {
  id: 'orderDate',
  displayName: <FormattedMessage {...messages.orderDate} />,
  type: OptionFormTypes.TYPE_ORDER_DATE_COMPARISON,
  filterValue: 'OrderDateTime',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_DATE_COMPARISON, criteriaInformations);
  },
};
